var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductsGridInfinite',{attrs:{"elements":_vm.products,"mediaType":_vm.product.mediaType,"infiniteId":_vm.recommendationType,"isProduct2025":_vm.isProduct2025},on:{"load-more":_vm.loadMoreProducts}})}
var staticRenderFns = []

export { render, staticRenderFns }